import "./EmployeeList.css";
import EmployeeItem from "../employeeItem/EmployeeItem";
import {useEffect, useState} from "react";
import axios from "axios";
import LoadingSpinner from "../../../../sharedComponents/LoadingSpinner/LoadingSpinner";
import { Link } from "react-router-dom";
import Logout from "../../../../sharedComponents/Logout";

function EmployeeList(props) {

    const [activeIsLoading, setActiveIsLoading] = useState(true);
    const [inActiveIsLoading, setInActiveIsLoading] = useState(true);
    const [limitIsLoading, setLimitIsLoading] = useState(true)

    const [activeEmployees, setActiveEmployees] = useState(null);
    const [inActiveEmployees, setInActiveEmployees] = useState(null);

    const [limitEmployee, setLimitEmployee] = useState(null);
    const [currentEmployee, setCurrentEmployee] = useState(null);

    useEffect(() => {
        // Shared sorting function to group by Area ID, then by Employee Name
        const sortByArea = (a, b) => {
            const areaA = (a.assigned_area_ids && a.assigned_area_ids.length > 0) ? a.assigned_area_ids[0] : 'zzzzz';
            const areaB = (b.assigned_area_ids && b.assigned_area_ids.length > 0) ? b.assigned_area_ids[0] : 'zzzzz';

            if (areaA < areaB) return -1;
            if (areaA > areaB) return 1;

            const nameA = `${a.first_name} ${a.last_name}`.toLowerCase();
            const nameB = `${b.first_name} ${b.last_name}`.toLowerCase();

            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;

            return 0; 
        };

        axios.get('employee/getActive').then(results => {
            const sortedActive = results.data.sort(sortByArea);
            setActiveEmployees(sortedActive);
            setActiveIsLoading(false);
        }).catch(() => { Logout()})

        axios.get('employee/getInactive').then(results => {
            const sortedInactive = results.data.sort(sortByArea);
            setInActiveEmployees(sortedInactive);
            setInActiveIsLoading(false);
        })  
    }, []);

    useEffect(() => {
        axios.get('info').then(results => {
            setLimitEmployee(results.data.max_employees);
            if(activeEmployees != null) {
                setCurrentEmployee(activeEmployees.length)
                setLimitIsLoading(false)
            }
        }).catch(() => { Logout()})
    }, [activeEmployees])

    const handleEmployeeClick = () => {
        localStorage.removeItem("selectedMonthShift")
    }

    /**
     * Helper to determine an employee's rank based on the chronological selection order.
     * If an employee belongs to multiple selected areas, the one selected EARLIEST wins.
     */
    const getEmployeeSortRank = (employee, orderedAreas) => {
        if (!employee.assigned_area_ids || employee.assigned_area_ids.length === 0) return 99999;
        
        let bestIndex = 99999; 
        
        employee.assigned_area_ids.forEach(empAreaId => {
            const index = orderedAreas.findIndex(orderedArea => String(orderedArea.id) === String(empAreaId));
            if (index !== -1 && index < bestIndex) {
                bestIndex = index;
            }
        });
        
        return bestIndex;
    };

    function createActiveEmployees() {
        if (!activeEmployees) return [];

        let filteredEmployees = activeEmployees.filter((item) => {
            let firstLastNameCombination = item.first_name + " " + item.last_name;
            let lastFirstNameCombination = item.last_name + " " + item.first_name;
            let idCombination = item.id;

            const searchMatches = props.searchInputText === '' || 
                    firstLastNameCombination.toUpperCase().includes(props.searchInputText.toUpperCase()) || 
                    lastFirstNameCombination.toUpperCase().includes(props.searchInputText.toUpperCase()) || 
                    idCombination.toUpperCase().includes(props.searchInputText.toUpperCase());
            
            const areaMatches = props.selectedArea === null ||
                    props.selectedArea.assigned_employee_ids.includes(idCombination);

            return searchMatches && areaMatches;
        });

        if (props.selectedArea && props.selectedArea.ordered_areas) {
            filteredEmployees.sort((a, b) => {
                const indexA = getEmployeeSortRank(a, props.selectedArea.ordered_areas);
                const indexB = getEmployeeSortRank(b, props.selectedArea.ordered_areas);

                if (indexA !== indexB) return indexA - indexB;

                const nameA = `${a.first_name} ${a.last_name}`.toLowerCase();
                const nameB = `${b.first_name} ${b.last_name}`.toLowerCase();
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
            });
        }

        return filteredEmployees.map((item, index) => (
            <Link to={'employeeView?employeeId=' + item.id} key={item.id || index} 
                state={{ shiftIssue: item.has_not_completed_shift || item.has_unresolved_shift_objection }} 
                onClick={handleEmployeeClick} 
            >
                <EmployeeItem notCompleted={item.has_not_completed_shift} 
                    firstName={item.first_name}
                    lastName={item.last_name} 
                    id={item.id} 
                    unresolvedShiftObjection={item.has_unresolved_shift_objection}
                />
            </Link>
        ));
    }

    function createInactiveEmployees() {
        if (!inActiveEmployees) return [];

        let filteredEmployees = inActiveEmployees.filter((item) => {
            let firstLastNameCombination = item.first_name + " " + item.last_name;
            let lastFirstNameCombination = item.last_name + " " + item.first_name;
            let idCombination = item.id;

            const searchMatches = props.searchInputText === '' || 
                    firstLastNameCombination.toUpperCase().includes(props.searchInputText.toUpperCase()) || 
                    lastFirstNameCombination.toUpperCase().includes(props.searchInputText.toUpperCase()) || 
                    idCombination.toUpperCase().includes(props.searchInputText.toUpperCase());
            
            const areaMatches = props.selectedArea === null ||
                    props.selectedArea.assigned_employee_ids.includes(idCombination);

            return searchMatches && areaMatches;
        });

        if (props.selectedArea && props.selectedArea.ordered_areas) {
            filteredEmployees.sort((a, b) => {
                const indexA = getEmployeeSortRank(a, props.selectedArea.ordered_areas);
                const indexB = getEmployeeSortRank(b, props.selectedArea.ordered_areas);

                if (indexA !== indexB) return indexA - indexB;

                const nameA = `${a.first_name} ${a.last_name}`.toLowerCase();
                const nameB = `${b.first_name} ${b.last_name}`.toLowerCase();
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
            });
        }

        return filteredEmployees.map((item, index) => (
            <Link to={'employeeView?employeeId=' + item.id} key={item.id || index}>
                <EmployeeItem firstName={item.first_name} lastName={item.last_name} id={item.id}/>
            </Link>
        ));
    }

    if (activeIsLoading || inActiveIsLoading || limitIsLoading) {
        return (<LoadingSpinner/>);
    } else {
        return (
            <div className="employee-list-container">
                <p className="active-profile-header">Aktiviert <span className="text-gray" >({currentEmployee}/{limitEmployee})</span> </p>
                {createActiveEmployees()}
                <p className="inactive-profile-header">Deaktiviert</p>
                {createInactiveEmployees()}
            </div>
        )
    }

}

export default EmployeeList;